export const TABS = {
  OVERVIEW: 'overview',
  SHIFT_DETAILS: 'shiftDetails',
  ADDITIONAL_INFO: 'additionalInfo',
  LEGAL_INFO: 'legalInfo',
};

export const TAB_ORDER = [TABS.OVERVIEW, TABS.SHIFT_DETAILS, TABS.ADDITIONAL_INFO, TABS.LEGAL_INFO];

export const SAVE_STATUS = {
  SAVING: 'saving',
  SAVED: 'saved',
  ERROR: 'error',
  LOCAL_ONLY: 'localOnly',
};

export const EARLY_PUNCH_WINDOW_OPTIONS = [0, 5, 10, 15];
export const DEFAULT_EARLY_PUNCH_WINDOW = 15;
export const PUNCH_ROUNDING_OPTIONS = [1, 5, 10, 15];
export const DEFAULT_PUNCH_ROUNDING = 1;
export const MIN_PUNCH_DISTANCE_METERS = 100;

export const DEFAULT_NEW_SHIFT = { name: '', start: 0, end: 8 * 60 };

const OPTION_LABEL_PREFIX = 'page.positionTemplateDetail.form.field.options';

export const BRANCH_OPTIONS = [
  { value: 'Albany General Staffing', labelId: `${OPTION_LABEL_PREFIX}.albanyGeneralStaffing` },
  { value: 'Buffalo General Staffing', labelId: `${OPTION_LABEL_PREFIX}.buffaloGeneralStaffing` },
  { value: 'Proflex', labelId: `${OPTION_LABEL_PREFIX}.proflex` },
  {
    value: 'Rochester General Staffing',
    labelId: `${OPTION_LABEL_PREFIX}.rochesterGeneralStaffing`,
  },
  { value: 'Rochester Medical', labelId: `${OPTION_LABEL_PREFIX}.rochesterMedical` },
  {
    value: 'Syracuse General Staffing',
    labelId: `${OPTION_LABEL_PREFIX}.syracuseGeneralStaffing`,
  },
];

export const LEGAL_BUSINESS_ENTITY_OPTIONS = [
  { value: 'Career Start', labelId: `${OPTION_LABEL_PREFIX}.careerStart` },
  { value: 'Tallavera', labelId: `${OPTION_LABEL_PREFIX}.tallavera` },
];

// The API stores benefits packages as numeric ids (1 = Career Start, 3 = Tallavera).
export const BENEFITS_PACKAGE_OPTIONS = [
  { value: 1, labelId: `${OPTION_LABEL_PREFIX}.careerStart` },
  { value: 3, labelId: `${OPTION_LABEL_PREFIX}.tallavera` },
];

export const PAY_GROUP_OPTIONS = [
  { value: 'W1', labelId: `${OPTION_LABEL_PREFIX}.W1` },
  { value: 'W2', labelId: `${OPTION_LABEL_PREFIX}.W2` },
  { value: 'W3', labelId: `${OPTION_LABEL_PREFIX}.W3` },
];
